// extracted by mini-css-extract-plugin
export default {"name":"NamedInputs_name__Z9lE2","input":"NamedInputs_input__yX+9i"};